import type React from 'react'

import type { MonthlyUsage as MonthlyUsageData } from '@/services/apiUsage'
import { UsageCard } from './components'
import css from './styles.module.scss'

interface MonthlyUsageProps {
  monthly: MonthlyUsageData
}

export const MonthlyUsage: React.FC<MonthlyUsageProps> = ({ monthly }) => (
  <div className={css.container}>
    <h2 className={css.title}>Monthly usage</h2>

    <div className={css.grid}>
      <UsageCard label="Read" bucket={monthly.read} />
      <UsageCard label="Write" bucket={monthly.write} />
    </div>
  </div>
)
